module.exports = __webpack_public_path__ + "03_mustache_brown.11c6944a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer3/03_mustache_brown.png
// module id = gJY+
// module chunks = 0